<template>
 <div >
   <div class="detailsTitle">
      <h4>划转记录</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="110px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
               <el-form-item label="转出账户名称:" prop="customerName">
                <el-input  placeholder="" v-model="searchFrom.customerName"></el-input>
              </el-form-item>
               <el-form-item label="转出账号:" prop="zxAccNo">
                <el-input  placeholder="" v-model="searchFrom.zxAccNo"></el-input>
              </el-form-item>
               <el-form-item label="转入账户名称:" prop="recCustomerName">
                <el-input  placeholder="" v-model="searchFrom.recCustomerName"></el-input>
              </el-form-item>
               <el-form-item label="转入账号:" prop="recZxAccNo">
                <el-input  placeholder="" v-model="searchFrom.recZxAccNo "></el-input>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
           <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="银行付款流水" width="180">
          <template slot-scope="scope">
            <span style="color: #0e6eec;cursor: pointer;" @click="huidanFn(scope.row)">{{scope.row.ext1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="银行收款流水" width="180">
          <template slot-scope="scope">
            <span style="color: #0e6eec;cursor: pointer;" @click="huidanFn1(scope.row)">{{scope.row.ext2}}</span>
          </template>
        </el-table-column>
        <el-table-column property="customerName" width="270"  :formatter="emptyFn"   label="转出账户名称"></el-table-column>
        <el-table-column property="zxAccNo" width="200"  :formatter="emptyFn"   label="转出账号"></el-table-column>
        <el-table-column property="recCustomerName" width="270"  :formatter ="emptyFn"   label="转入账户名称"></el-table-column>
        <el-table-column property="recZxAccNo" width="200"  :formatter="emptyFn"   label="转入账号 "></el-table-column>
        <el-table-column property="transMoney" width="150"  :formatter="emptyFn"   label="划转金额(元)"></el-table-column>
        <el-table-column property="reason"  width="260"  :formatter="emptyFn"   label="划转原因"></el-table-column>
        <el-table-column property="createUserName"  width="200"  :formatter="emptyFn"   label="操作人"></el-table-column>
        <el-table-column property="createTime"  width="170"  :formatter="dateTimeFormat"   label="操作时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>

</template>

<script>
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { chaKanHuiDan } from '@/utils/chaKanHuiDan'
import {
  tTransMoneyInfoLIst // 列表
} from '@/api/consignment'
export default {
  data () {
    let id = this.$route.query.id
    let type = this.$route.query.type
    return {
      id: id,
      type: type,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询
      searchFrom: {
        pageNo: 1,
        pageSize: 50
        // accountId: id,
        // extertransTypes: [1, 2, 3, 4, 5]
      },
      tableList: [],
      loading: false,
      total: 0,
      isDisable: false

    }
  },
  created () {
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 132) + 'px'
  },
  methods: {
    // 银行回单
    huidanFn (row) {
      chaKanHuiDan(row.ext1, row.createTime)
    },
    huidanFn1 (row) {
      chaKanHuiDan(row.ext2, row.createTime)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      // console.log(selection)
      // this.weight = 0.00
      // selection.forEach(item => {
      //   this.weight += item.weight
      // })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      tTransMoneyInfoLIst(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTimes: null
        // accountId: this.id,
        // extertransTypes: [1, 2, 3, 4, 5]
      }
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
</style>
